import { headerLogoEndTitle } from './HeaderLogoStore.js';

export const updateHeaderLogoEndTitle = (value) => headerLogoEndTitle.update((oldValue) => value);
